import { render, staticRenderFns } from "./SampleRequestEditTabBasic.vue?vue&type=template&id=2f6ce568&"
import script from "./SampleRequestEditTabBasic.vue?vue&type=script&lang=js&"
export * from "./SampleRequestEditTabBasic.vue?vue&type=script&lang=js&"
import style0 from "./SampleRequestEditTabBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports